module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "galley-rw"
  }, [_c('section', {
    staticClass: "body-rw Chapter-rw auto-rw page-open-left-rw",
    attrs: {
      "epub:type": "bodymatter chapter"
    }
  }, [_c('h1', {
    staticClass: "chapter-number"
  }, [_c('a', {
    attrs: {
      "id": "page-15"
    }
  }), _c('a', {
    attrs: {
      "href": "#/toc#toc-chapter001"
    }
  }, [_vm._v("1")])]), _vm._v(" "), _c('h1', {
    staticClass: "chapter-title"
  }, [_c('a', {
    attrs: {
      "href": "#/toc#toc-chapter001"
    }
  }, [_vm._v("GET SMART ABOUT "), _c('strong', [_vm._v("ALCOHOL")])])]), _vm._v(" "), _c('p', {
    staticClass: "center-para"
  }, [_vm._v("It can boost brain cells or destroy them")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("Y")]), _vm._v("our brain may like a little alcohol, but not a lot. Study after study shows that moderate drinkers are less apt to develop Alzheimer’s. Recent research at Wake Forest University Baptist Medical Center found that older people who drank eight to fourteen alcoholic beverages per week—one or two a day—had a 37 percent lower risk of dementia than nondrinkers. The bad news: stepping into the “heavy drinker” category—more than fourteen drinks a week—doubled the odds of developing dementia compared to not drinking.")]), _vm._v(" "), _c('p', [_vm._v("UCLA researchers find that heavy drinking pushes you two to three years closer to Alzheimer’s. And heavy drinkers who also carry the ApoE4 Alzheimer’s gene can expect the onset of dementia four to six years earlier. Further, in the large Framingham Heart Study, a community health study spanning several decades, heavy drinking (more than fourteen "), _c('a', {
    attrs: {
      "id": "page-16"
    }
  }), _vm._v("drinks a week) predicted shrinkage in the memory regions of the brain.")]), _vm._v(" "), _c('p', [_vm._v("British doctors writing in the "), _c('em', [_vm._v("British Journal of Psychiatry")]), _vm._v(" recently warned that heavy and binge drinking among older people is creating “a silent epidemic” of alcohol-related dementia that causes as much as 10 percent of all cases of dementia.")]), _vm._v(" "), _c('p', [_vm._v("Even adults who usually drink lightly or moderately but go on occasional binges face a higher risk of dementia. A Finnish study showed that adults who binged in midlife at least once a month—drinking, for example, more than five bottles of beer or a bottle of wine at one sitting—were three times more likely to develop dementia, including Alzheimer’s, twenty-five years later. Passing out from alcohol at least twice in one year hiked the chances of developing dementia by ten times.")]), _vm._v(" "), _c('p', [_vm._v("On the other hand, a daily cocktail or glass of wine may help delay dementia. Research finds that alcohol is an anti-inflammatory (inflammation promotes Alzheimer’s) and raises good HDL cholesterol, which helps ward off dementia. High antioxidants in red wine give it additional anti-dementia clout. Such antioxidants, including resveratrol, act as anticoagulants and artery relaxants, dilating blood vessels and increasing blood flow, which encourages cognitive functioning. That makes many researchers favor red wine over white wine, which has comparatively few antioxidants. (See “Make It Wine, Preferably Red,” "), _c('span', {
    attrs: {
      "href": "#/chapter100#page-282",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("here")]), _vm._v(".)")]), _vm._v(" "), _c('p', {
    staticClass: "space-break"
  }, [_c('a', {
    attrs: {
      "id": "page-17"
    }
  }), _c('strong', [_c('span', {
    staticClass: "special"
  }, [_vm._v("What to do?")])]), _vm._v(" Understand that alcohol in low doses over an adult’s lifetime appears brain protective, but large doses at one time kill or cripple brain cells, leaving you more vulnerable to cognitive dysfunction and Alzheimer’s decades later. The toxic impact is long lasting. If you do drink, stick to low or moderate amounts, sipped slowly, preferably with food. That means no more than one drink a day for women, two for men. One drink usually means a twelve-ounce beer, a shot of liquor, or five ounces of wine.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7899f9cc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter001.vue
// module id = 81
// module chunks = 0